import { createGlobalStyle } from 'styled-components';

export const sizes = {
    desktop: 992,
    phone: 576,
    tablet: 768,
};

export default createGlobalStyle`
  body {
    margin: 0;
    height: 100vh;
  } 

  * {
    box-sizing: border-box;
    line-height: 1.4;
  }

  #rezdy-logo-left {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width:  calc(100% - 32px);
    max-height: 40px;
  }

  #rezdy-swish-left {
    object-fit: contain;
    object-position: left;
    max-width: 100%;
    height: 100%;
  }

  #root {
    /* max-width: 400px; */
    height: 100%;
    width: 100%;
    /* display: flex; */
    
  }
`;
